<template>
  <div class="question">
    <navBar />
    <div class="form-content">
      <a-spin :spinning="spinLoading" tip="加载中...">
        <a-form-model v-bind="formItemLayoutWithOutLabel">
          <a-form-model-item v-bind="formItemLayout" label="常见问题开头语">
            <a-input :style="styleValue" v-model="description"></a-input>
          </a-form-model-item>
          <a-divider></a-divider>
          <a-form-model-item v-bind="formItemLayoutWithOutLabel">
            <a-button type="dashed" style="width: 60%" @click="addQuestion">
              <a-icon type="plus" /> 添加问题
            </a-button>
          </a-form-model-item>
          <div v-for="(item, index) in list_show" :key="index">
            <a-divider></a-divider>
            <a-form-model-item
              v-bind="formItemLayout"
              :label="'问题' + (list_show.length - index)"
            >
              <a-input
                v-model="item.keyword"
                placeholder="请输入问题"
                :style="styleValue"
              />
              <a-icon
                class="dynamic-delete-button"
                type="minus-circle-o"
                @click="removeQuestion(item)"
              />
            </a-form-model-item>
            <a-form-model-item
              v-bind="formItemLayout"
              :label="'答案' + (list_show.length - index)"
            >
              <a-input
                v-model="item.answer"
                placeholder="请输入答案"
                :style="styleValue"
              />
            </a-form-model-item>
            <a-form-model-item
              v-bind="formItemLayout"
              :label="'描述' + (list_show.length - index)"
            >
              <a-input
                v-model="item.description"
                placeholder="请输入描述"
                :style="styleValue"
              />
            </a-form-model-item>
          </div>
        </a-form-model>
      </a-spin>
      <div class="footer">
        <a-button type="primary" @click="submitForm" :loading="btnLoading">
          保存
        </a-button>
        <a-button style="margin-left: 10px" @click="cancelForm">
          取消
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import navBar from "@components/navBar";
export default {
  name: "question",
  components: {
    navBar,
  },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
      list: [],
      description: "",
      styleValue: "width: 60%; margin-right: 8px",
      btnLoading: false,
      spinLoading: false,
    };
  },
  computed: {
    list_show() {
      let list = this.list.filter((item) => item.status >= 0).reverse();
      return list;
    },
  },
  mounted() {
    this.queryFaqList();
  },
  methods: {
    queryFaqList() {
      this.spinLoading = true;
      this.$axios({
        url: this.$api.queryFaqList,
        data: { platform: "didi_fruit" },
      }).then((res) => {
        this.spinLoading = false;
        this.list = res.result.keys;
        this.description = res.result.description;
      });
    },
    submitForm() {
      let err_msg = "";
      for (let i = 0; i < this.list.length; i++) {
        let item = this.list[i];
        if (!item.answer) {
          err_msg = `回答${i + 1}不能为空`;
        }
        if (!item.keyword) {
          err_msg = `问题${i + 1}不能为空`;
        }
        if (err_msg) {
          break;
        }
      }
      if (err_msg) {
        this.$message.warning(err_msg);
        return;
      }
      this.btnLoading = true;
      Promise.all([
        this.deleteHandle(),
        this.saveHandle(),
        this.saveFaqDesc(),
      ]).then(() => {
        this.btnLoading = false;
        this.$message.success("保存成功");
      });
    },
    cancelForm() {
      this.queryFaqList();
    },
    removeQuestion(item) {
      let index = this.list.indexOf(item);
      if (item.id) {
        item.status = -1;
      } else {
        this.list.splice(index, 1);
      }
    },
    addQuestion() {
      this.list.push({
        keyword: "",
        answer: "",
        description: "",
        status: 0,
      });
    },
    deleteHandle() {
      return new Promise((resolve) => {
        let list = this.list.filter((item) => item.status === -1);
        let num = 0;
        if (list.length) {
          list.forEach((item) => {
            this.$axios({
              url: this.$api.deleteFaq,
              data: {
                id: item.id,
              },
            }).then(() => {
              if (++num === list.length) {
                resolve();
              }
            });
          });
        } else {
          resolve();
        }
      });
    },
    saveHandle() {
      return new Promise((resolve) => {
        let list = this.list_show;
        let num = 0;
        if (list.length) {
          list.forEach((item) => {
            let data = {
              keyword: item.keyword,
              answer: item.answer,
              description: item.description,
            };
            if (item.id) {
              data.id = item.id;
            }
            this.$axios({
              url: this.$api.createOrUpdateFaq,
              data,
            }).then(() => {
              if (++num === list.length) {
                resolve();
              }
            });
          });
        } else {
          resolve();
        }
      });
    },
    saveFaqDesc() {
      return new Promise((resolve) => {
        let data = {
          description: this.description,
        };
        this.$axios({
          url: this.$api.saveFaqDesc,
          data,
        }).then(() => {
          resolve();
        });
      });
    },
  },
};
</script>

<style lang='scss' scoped>
@import "@css/mixin.scss";
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: $error-color;
  transition: all 0.3s;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
.form-content {
  padding-bottom: 100px !important;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 216px;
  width: calc(100% - 232px);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  background-color: #fff;
  // box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
  border-top: 1px solid #ddd;
}
</style>